import {
    Catalog,
    CatalogValue,
    CatalogValuesResponse,
    EfeCatalog,
    EfeCatalogValue,
} from 'commons/models';
import {Utils} from 'commons';

/**
 * Parse Catalog to EfeCatalog
 * @param {Catalog} from
 * @returns {EfeCatalog}
 */
export function toEfeCatalog(from: Catalog) {
    const to: EfeCatalog = {
        id: from.idCatalog,
        name: from.cveCatalog,
        description: from.dsCatalog,
        status: from.status || 'I',
        values: [],
        size: 0,
    };
    return to;
}

/**
 * Parse CatalogValuesResponse to EfeCatalogValue
 * @param {CatalogValuesResponse} from
 * @returns {EfeCatalogValue}
 */
export function toEfeCatalogWithValues(from: CatalogValuesResponse) {
    const to: EfeCatalog = {
        id: from.idCatalog,
        name: from.cveCatalog,
        description: from.dsCatalog,
        size: from.totalElements,
        createdAt: from.createdAt,
        updatedAt: from.updatedAt,
        // Sort by 'value' for EfeAutoComplete values
        values: Utils.functions
            .sort(from.data, 'value')
            .map((val) => toEfeCatalogValues(val)),
    };
    return to;
}

/**
 * Parse CatalogValue to EfeCatalogValue
 * @param {CatalogValue} from
 * @returns {EfeCatalogValue}
 */
export function toEfeCatalogValues(from: CatalogValue) {
    const to: EfeCatalogValue = {
        id: from.id,
        order: from.sequenceId,
        value: from.value,
        secondaryId: from.secondaryId,
        secondaryValue: from.secondaryValue,
        status: from.status || 'A',
        createdAt: from.createdAt,
        updatedAt: from.updatedAt,
    };
    return to;
}
